import { useEffect, useState } from "react";
import { safeFetch } from "@/api/safeFetch";
import { ButtonSiguiente } from "@/components/ui";
import { UsuarioDetalle } from "@/types";

interface RehabilitarUsuarioAdminProps {
  usuario: UsuarioDetalle;
  onDone: () => void;
}

const RehabilitarUsuarioAdmin: React.FC<RehabilitarUsuarioAdminProps> = ({
  usuario,
  onDone,
}) => {
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const token = localStorage.getItem("token") ?? "";

  const rehabilitar = async () => {
    const ok = window.confirm(
      `✅ Vas a REHABILITAR al usuario @${usuario.nombre_usuario}.\n\nPodrá volver a acceder al sistema.`
    );
    if (!ok) return;

    const controller = new AbortController();
    const signal = controller.signal;

    setWorking(true);
    setError(null);

    try {
      const res = await safeFetch(
        `/api/admin/usuarios/${usuario.usuario_id}/rehabilitar`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          signal
        }
      );

      if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error(json.message || "Error al rehabilitar usuario");
      }

      alert("✅ Usuario rehabilitado correctamente");
      onDone();
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setError(err.message);
      }
    } finally {
      setWorking(false);
    }

    return () => controller.abort();
  };


  useEffect(() => {
    return () => {
      setWorking(false);
      setError(null);
    };
  }, []);


  return (
    <div className="bg-white p-4 rounded shadow space-y-4">
      <h3 className="font-bold text-lg text-green-700">
        ✅ Rehabilitar usuario
      </h3>

      <p>
        <b>Usuario:</b> @{usuario.nombre_usuario}
      </p>
      <p>
        <b>Email:</b> {usuario.email}
      </p>

      {error && <p className="text-red-600 font-semibold">{error}</p>}

      <div className="flex gap-3">
        <ButtonSiguiente
          onClick={onDone}
          className="flex-1 bg-gray-300 hover:bg-gray-400"
        >
          Cancelar
        </ButtonSiguiente>

        <ButtonSiguiente
          onClick={rehabilitar}
          disabled={working}
          className="flex-1 bg-green-600 hover:bg-green-700 text-white"
        >
          {working ? "Procesando…" : "✅ Rehabilitar"}
        </ButtonSiguiente>
      </div>
    </div>
  );
};

export default RehabilitarUsuarioAdmin;
